import { ErrorDialog, ErrorDialogProps } from "@codat/orchard-ui";
import useJwtProp from "hooks/useJwtProp";
import React from "react";

import styles from "./Error.module.scss";

interface SupportRequestFormDetails {
  zendeskFormId?: string;
  email?: string;
  subject?: string;
  description?: string;
  companyId?: string;
}

interface ZendeskTicketOptions {
  statusCode: number | undefined;
  correlationId: string | undefined;
  message: string | undefined;
  email: string;
}

export const formatSupportTicket = ({
  correlationId,
  statusCode,
  email,
  message,
}: ZendeskTicketOptions): SupportRequestFormDetails => {
  const formattedMessage = message ? ` - ${message}` : "";
  const formattedSubjectStatusCode = statusCode
    ? `${statusCode} error`
    : "Error";
  const formattedSubjectCorrelationId = correlationId
    ? ` - ${correlationId}`
    : "";
  return {
    email,
    zendeskFormId: "",
    subject: `${formattedSubjectStatusCode}${formattedSubjectCorrelationId}`,
    description: `${
      statusCode || message
        ? `Error: ${statusCode ?? ""}${formattedMessage}`
        : "Error"
    }<br>
    URL: ${window.location.href ?? "Not provided"}<br>
    Correlation ID: ${correlationId ?? "Not provided"}
    <br><br>
    <i>Please describe what you were doing when you encountered the issue.</i>`,
  };
};

const Error = ({ statusCode, message, correlationId }: ErrorDialogProps) => {
  const email = useJwtProp("user_email");

  return (
    <div className={styles.errorPage} role="alert">
      <ErrorDialog
        message={message}
        statusCode={statusCode}
        correlationId={correlationId}
        supportRequestFormOptions={formatSupportTicket({
          statusCode,
          message: typeof message === "string" ? message : undefined,
          correlationId,
          email,
        })}
      />
    </div>
  );
};

export default Error;
